import { addFilters } from './filters';
import customAttributes from "./common/attributes/customAttributes";
import { mdComment } from './comment/edit';
import windowLoad from "./common/component/windowLoad";
import { registerFormats } from './common/format';
import sideBar from "./sidebar/board-sidebar";

const { registerFormatType } = wp.richText;


// Initialize filters and formats
addFilters();
registerFormats();
registerFormatType(mdComment.name, mdComment);
